import React from "react";
import { List, Datagrid, FunctionField } from "react-admin";

import moment from "moment";
import styled from "styled-components";

const StyledDiv = styled.div(props => ({
  flexDirection: "column",
  alignItems: props.align ? props.align : "flex-start",
  justifyContent: props.justify ? props.justify : "center",
  backgroundColor: props.bgcolor,
  color: props.color,
  paddingTop: props.padding ? props.padding : "0px !important",
  paddingBottom: props.padding ? props.padding : "0px !important",
  minHeight: "60px",
  display: "flex",
  minWidth: "100px",
  marginLeft: "-15px",
  marginRight: "-15px",
  paddingLeft: "10px",
  padding: "20px"
}));

const VechicleObsPaginaton = () => {
  return "";
};

export const VehicleObsolenceList = props => {
  return (
    <React.Fragment>
      <List
        {...props}
        resource="bike_obsolence"
        bulkActionButtons={false}
        title="Fleet Obsolescence"
        pagination={<VechicleObsPaginaton />}
      >
        <Datagrid>
          <FunctionField
            sortable={false}
            label="Id"
            render={bike => (
              <StyledDiv
                color={bike.mileage > 33000 ? "red" : ""}
                bgcolor={
                  moment(bike.date).format("M") > moment().format("M") &&
                    moment(bike.date).format("Y") === moment().format("Y")
                    ? "#E7F3F1"
                    : ""
                }
              >
                {bike.id}
              </StyledDiv>
            )}
          />

          <FunctionField
            label="Date"
            render={bike => (
              <StyledDiv
                color={bike.mileage > 33000 ? "red" : ""}
                bgcolor={
                  moment(bike.date).format("M") > moment().format("M") &&
                    moment(bike.date).format("Y") === moment().format("Y")
                    ? "#E7F3F1"
                    : ""
                }
              >
                {moment(bike.date).format("MMMM YYYY")}
              </StyledDiv>
            )}
          />
          <FunctionField
            sortable={false}
            label="Bike"
            render={bike => {
              const bikeData = bike.bike.split(" ");
              return (
                <StyledDiv
                  color={bike.mileage > 33000 ? "red" : ""}
                  bgcolor={
                    moment(bike.date).format("M") > moment().format("M") &&
                      moment(bike.date).format("Y") === moment().format("Y")
                      ? "#E7F3F1"
                      : ""
                  }
                >
                  {bikeData[0]} <br />
                  {bikeData[1]} <br />
                  {bike.lowv ? "*LOW" : ""}
                </StyledDiv>
              );
            }}
          />
          <FunctionField
            sortable={false}
            label="Current Km"
            render={bike => (
              <StyledDiv
                color={bike.mileage > 33000 ? "red" : ""}
                bgcolor={
                  moment(bike.date).format("M") > moment().format("M") &&
                    moment(bike.date).format("Y") === moment().format("Y")
                    ? "#E7F3F1"
                    : ""
                }
              >
                {bike.mileage}
              </StyledDiv>
            )}
          />

          <FunctionField
            sortable={false}
            label="Expected Km"
            render={bike => (
              <StyledDiv
                color={bike.mileage > 33000 ? "red" : ""}
                bgcolor={
                  moment(bike.date).format("M") > moment().format("M") &&
                    moment(bike.date).format("Y") === moment().format("Y")
                    ? "#E7F3F1"
                    : ""
                }
              >
                {bike.km}
              </StyledDiv>
            )}
          />

          <FunctionField
            sortable={false}
            label="Total Expected Km"
            render={bike => (
              <StyledDiv
                color={bike.mileage > 33000 ? "red" : ""}
                bgcolor={
                  moment(bike.date).format("M") > moment().format("M") &&
                    moment(bike.date).format("Y") === moment().format("Y")
                    ? "#E7F3F1"
                    : ""
                }
              >
                {bike.km_total}
              </StyledDiv>
            )}
          />
        </Datagrid>
      </List>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/resources/bike_obsolence.js